import { FC, useEffect, useState } from "react";
import { Modal } from "@sainsburys-tech/luna-modal";
import "./AddFieldModal.scss";
import { ModalProps } from "../../../../Interfaces/IModalProps";
import FamilyGroupManagementEdit from "../Edit-FamilyGroupManagement/familyGroupManagementFields";
import { consolelog } from "../../../../helpers/consolelog";

const AddFieldModal: FC<ModalProps> = ({
  isOpen,
  handleClose,
  handleAddCallback: handleAdd,
}) => {
  const closeHandler = () => {
    handleClose(false);
  };

  return (
    <>
      <div className="familyGroupModal">
        <Modal
          classNanme="familyGroupModal"
          fullScreen
          restrictClose
          alert
          handleClose={() => handleClose}
          open={isOpen}
          headingId="dialog-modal"
        >
          <FamilyGroupManagementEdit
            closeModal={closeHandler}
            isEdit={false}
            title={"Create Family Group"}
          />
        </Modal>
      </div>
    </>
  );
};

export default AddFieldModal;
